/* eslint @typescript-eslint/explicit-module-boundary-types: 0 */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GeneralState } from './general.reducer';

const selectGeneralDataFeature = createFeatureSelector<GeneralState>('general');

export const selectIsLoggedIn = createSelector(selectGeneralDataFeature, (state) => state.isLoggedIn);

export const selectIsMobile = createSelector(selectGeneralDataFeature, (state) => state.platform === 'mobile');

export const selectSectionWWW = createSelector(selectGeneralDataFeature, (state) => state.sectionWWW);
